module.exports = __webpack_public_path__ + "media/images/games/35gender/readingbooks-fcb68bfbba3a5b473967fb838daa6fea.png";